import { TableJoinRequestsComponent } from '../../components/table-join-requests/table-join-requests.component';
import { ListPagerComponent } from '../../components/list-pager/list-pager.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input } from '@angular/core';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';

@Component({
	standalone: true,
	selector: 'card-join-requests',
	templateUrl: './card-join-requests.component.html',
	imports: [ CommonModule, TableJoinRequestsComponent, ListPagerComponent, FormsModule ]
})
export class CardJoinRequestsComponent implements OnInit {
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	@Input() pageSize: any | undefined;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.joinRequests = [];
		this.vm.pageSize = 10;
	}

	currentPageChanged(newPage) {
		this.vm.currentPage = newPage;
		this.angularBroadcastHelperService.rootBroadcast("loadMorePages", newPage);
	}
	
}